import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import React from 'react'
import { FormFieldSubentity } from './form-field-subentity'
import { FormSubmitButtonSubentity } from './form-submit-button-subentity'
import { FormCheckboxSubentity } from './form-checkbox-subentity'
import { FormInterface } from 'src/shared/types/entities/form-interface'
import { CommonForm } from 'src/shared/entities/form'
import { FormSubentityTypeEnum } from 'src/shared/types/entities/form-interface'
import { useCalculateTypography } from '../../hooks/use-calculate-typography'
import { useManagement, useWebsiteSettings } from 'client/store'
import { getWebsiteStylesTypographyHeading } from 'src/editor/store/website-settings/website-settings-selector'
import { getSettingsEditing } from 'client/reducers/managementReducer'

export interface FormProps {
  entity: FormInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const Form = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: FormProps) => {
  const { calculatedFontSize } = useCalculateTypography()

  const {
    fontSize: websiteGlobalHeadingFontSize,
    mobileFontSize: websiteGlobalMobileHeadingFontSize,
  } = useWebsiteSettings(getWebsiteStylesTypographyHeading) || {}

  const { areSuccessOptInScreenSettingsOpened } =
    useManagement(getSettingsEditing) || {}
  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <CommonForm
        entity={entity}
        successOptInScreen={{
          fontSize: calculatedFontSize.desktop,
          mobileFontSize: calculatedFontSize.mobile,
          headerFontSize: websiteGlobalHeadingFontSize,
          headerMobileFontSize: websiteGlobalMobileHeadingFontSize,
          textColor: entity.action.successOptInScreen?.textColor,
          mobileTextColor: entity.action.successOptInScreen?.mobileTextColor,
        }}
        isSuccessOptInScreenOpened={areSuccessOptInScreenSettingsOpened}
      >
        {entity.subEntities.map(subentity => {
          if (subentity.type === FormSubentityTypeEnum.Field) {
            return (
              <FormFieldSubentity
                key={subentity.id}
                formEntity={entity}
                fieldSubentity={subentity}
              />
            )
          } else if (subentity.type === FormSubentityTypeEnum.Checkbox) {
            return (
              <FormCheckboxSubentity
                key={subentity.id}
                formEntity={entity}
                checkboxSubentity={subentity}
              />
            )
          } else {
            return (
              <FormSubmitButtonSubentity
                key={subentity.id}
                formEntity={entity}
                submitButtonSubentity={subentity}
              />
            )
          }
        })}
      </CommonForm>
    </BaseEntityNew>
  )
}
